import React, {Component, Fragment} from 'react';
import {inject, observer} from 'mobx-react';
import {action, observable} from 'mobx';
import {FormattedMessage} from 'react-intl';
import Close from 'react-icons/lib/io/close';
import Slide from '@material-ui/core/Slide';
import {isMobile} from '../../../utils/screenUtility';
import DialogWrapper from '../../../components/dialog/Dialog';
import InviteStudentForm from './InviteStudentForm';
import {DialogTypes} from '../../../constants/enums';
import {getUserMainInstrument} from '../../../utils/userUtility';
import './styles.scss';

@inject('dialogStore', 'inviteMemberStore')
@observer
class InviteStudentDialog extends Component {
    @observable activeForm = true;

    setActiveForm = (val) => action(() => {
        this.activeForm = val;
    });

    closeDialog = () => {
        this.props.dialogStore.closeDialog(DialogTypes.AddStudent);
    };

    handleExited = () => {
        this.props.inviteMemberStore.resetForm();
        this.props.inviteMemberStore.setConnectMode(false);
    };

    renderAddStudent = () => {
        return (
            <Fragment>
                <h3><FormattedMessage id="addStudent.form.title"/></h3>
                <Fragment>
                    <div className={`invite-student-block ${this.activeForm ? 'active' : 'disabled'}`}>
                        <InviteStudentForm
                            className="add-student-form"
                            showEmail={true}
                            instrument={getUserMainInstrument()}
                            submitLabel="selectStudent.cta.addStudent"
                        />
                    </div>
                </Fragment>
            </Fragment>
        );
    };

    renderConnectStudent = () => {
        const {inviteMemberStore} = this.props;
        return (
            <Fragment>
                <div className="avatar-wrap">
                    <img src={inviteMemberStore.avatar} alt=""/>
                </div>
                <p><FormattedMessage id="addStudent.description"/></p>
                <InviteStudentForm
                    className="connect-student-form"
                    showEmail={true}
                    instrument={getUserMainInstrument()}
                />
            </Fragment>
        );
    };

    render() {
        const {dialogStore, inviteMemberStore} = this.props;
        const dialogProps = {
            ...(isMobile() && {TransitionComponent: Slide}),
            TransitionProps: {direction: 'up'},
            classes: {root: 'invite-modal-root', paper: 'paper'},
            open: dialogStore.getDialogState(DialogTypes.AddStudent),
            onClose: this.closeDialog,
            onExited: this.handleExited
        };

        return (
            <DialogWrapper {...dialogProps}>
                <div className="invite-modal">
                    <button className="invite-modal-close" onClick={this.closeDialog}>
                        <Close/>
                    </button>
                    {inviteMemberStore.isConnectMode
                        ? this.renderConnectStudent()
                        : this.renderAddStudent()
                    }
                </div>
            </DialogWrapper>
        );
    }
}

export default InviteStudentDialog;
